import React, { useState, useEffect } from "react";
import { FaAddressBook, FaSearch, FaRegWindowClose } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Spinner from '../utils/Spinner';

const CustomHeader = ({ tableManager, modal_sc, setStringFilter, activeButton, setActiveButton, isLoading, setLoading, selectedRowsIds, allowWrite }) => {
  const { searchApi } = tableManager;
  const { searchText, setSearchText } = searchApi;
  const [timer, setTimer] = useState(null);

  const handleSearch = (filter) => {
    setLoading(true);
    setActiveButton(filter);
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        let updatedSearchText = searchText;
        const realTime = new Date();
        const currentDate = new Date(realTime.getFullYear(), realTime.getMonth(), realTime.getDate(), 0, 0, 0, 0);
        let newRange;
      
        if (filter === "next") {
          const nextDate = new Date(currentDate);
          nextDate.setFullYear(nextDate.getFullYear() + 10);
          newRange = `renew|${currentDate.toISOString()}|${nextDate.toISOString()}`;
        } else if (filter === "expired") {
          const expiredDate = new Date(currentDate);
          expiredDate.setFullYear(expiredDate.getFullYear() - 10);
          newRange = `renew|${expiredDate.toISOString()}|${currentDate.toISOString()}`;
        }
      
        updatedSearchText = updatedSearchText.replace(/&range=renew\|[^|]+\|[^|]+/, "");
        if (newRange) {
          updatedSearchText += `&range=${newRange}`;
        }

        setSearchText(updatedSearchText);
        setStringFilter(updatedSearchText);
        setLoading(false);
      }, 1000)
    );
  };

  return (
    <div style={styles.container}>
      {isLoading ? <Spinner /> : null}
      <ul style={styles.list}>

      <li className='styleUl'>
          {selectedRowsIds.length > 0 && allowWrite
            ? (<Button type="button" className="btn btn-warning" alt="Create" size="sm" onClick={() => { modal_sc(0, "Create"); }}> <FaAddressBook /> Edit MultiSelection </Button>)
            : ('')}
        </li>

        <li style={styles.listItemRightBtn}>
          <Button
            className={`btn btn-${activeButton === 'expired' ? 'primary' : 'secondary'}`}
            size="sm"
            title="Search"
            onClick={() => { handleSearch('expired'); }}
          >
            Expired
          </Button>

          <Button
            className={`btn btn-${activeButton === 'next' ? 'primary' : 'secondary'}`}
            size="sm"
            title="Search"
            onClick={() => { handleSearch('next'); }}
          >
            Next
          </Button>

          <Button
            className="btn btn-danger"
            size="sm"
            title="Clear"
            onClick={() => {
              window.location.href = "";
            }}
          >
            <FaRegWindowClose title="Clear" />
          </Button>
        </li>

      </ul>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 20px",
    background: "#fff",
    width: "100%",
    borderBottom: "1px solid #eee",
  },
  list: {
    listStyleType: "none",
  },
  listItemRightBtn: {
    float: "right",
    padding: "6px",
    width: "280px",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  }
};

export default CustomHeader;
